import { render, staticRenderFns } from "./ContractInfomationTab.vue?vue&type=template&id=23991508&scoped=true&"
import script from "./ContractInfomationTab.vue?vue&type=script&lang=ts&"
export * from "./ContractInfomationTab.vue?vue&type=script&lang=ts&"
import style0 from "./ContractInfomationTab.vue?vue&type=style&index=0&id=23991508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23991508",
  null
  
)

export default component.exports